import React from "react";
import { FaTags } from "react-icons/fa";
import { BASE_URL } from "../constants";
import CatalogAdminPage from "./CatalogAdminPage";

const Categories: React.FC = () => (
  <CatalogAdminPage
    title="Categorias"
    subtitle="Administre las categorias disponibles para clasificar productos."
    singularLabel="Categoria"
    searchPlaceholder="Buscar por nombre de categoria..."
    endpoint={`${BASE_URL}/categories`}
    Icon={FaTags}
  />
);

export default Categories;
